module.exports = __webpack_public_path__ + "img/2e3d8cb965c7a748e49380582bb18ac1.png";